<div class="professional-links-container">
  @if (isLoading()) {
    <multisite-loader-globe-animation-detail>
    </multisite-loader-globe-animation-detail>
  }

  @if (!isLoading()) {
    <div class="professional-links-content">
    <div class="page-header">
      <!-- <h2>{{ 'professional.links.title' | transloco }}</h2> -->
      <!-- <p class="page-subtitle">{{ 'profile.links.description' | transloco }}</p> -->
      <span *transloco="let t; scope:'profile'">{{t('profile.professional_links_description')}}</span>
    </div>

    @if (error()) {
      <div class="alert alert-danger" role="alert">
        <strong>{{ 'common.error' | transloco }}:</strong> {{ error() | transloco }}
      </div>
    }

    @if (!hasRole('Interculturalist')) {
        <!-- Completeness Status -->
        <multisite-tracking-completeness-status-card
        [isComplete]="professionalCompleteness().isComplete"
        [titleTranslationKey]="'profile.interculturalist_eligibility'"
        [titleTranslationScope]="'profile'"
        [descriptionTranslationKey]="'profile.interculturalist_eligibility_requirements_pending'"
        [descriptionTranslationScope]="'profile'"
        [completeBadgeTranslationKey]="'tracking.completed'"
        [incompleteBadgeTranslationKey]="'tracking.in_progress'"
        [requirements]="completenessRequirementItems()"
        ></multisite-tracking-completeness-status-card>
    }

    <!-- Professional Links by Type -->
    <div class="links-by-type-section">
      <!-- <h3>{{ 'professional.links.your_links' | transloco }}</h3> -->

      @for (template of userLinksService.professionalLinkTemplates(); track template.type) {
      <div class="professional-link-type">
        <div class="link-type-header">
          <div class="type-info">
            <i [class]="template.icon"></i>
            <div>
              <h4>
               @if(template.labelTranslationKey) {
                 <span *transloco="let t; scope:template.labelTranslationScope">{{t(template.labelTranslationKey)}}</span>
               } @else {
                 {{ template.labelText ?? '' }}
               }
              </h4>
                <p class="type-description">
                  @if(template.descriptionTranslationKey) {
                    <span *transloco="let t; scope:template.descriptionTranslationScope">{{t(template.descriptionTranslationKey)}}</span>
                  } @else {
                    {{ template.descriptionText ?? '' }}
                  }
                </p>
            </div>
          </div>
          @if (linksByType()[template.type].length === 0) {
            <button
              type="button"
              class="btn btn-sm btn-primary"
              (click)="onSelectType(template.type)"
              [disabled]="isAnythingLoading()"
              *transloco="let t"
            >
              {{t('common.add')}}
            </button>
          }
        </div>

        <!-- Links for this type -->
        @if (linksByType()[template.type].length > 0) {
        <div class="links-for-type">
          @for (link of linksByType()[template.type]; track link.id) {
          <div
            class="link-item"
            [class.editing]="editingLinkId() === link.id"
          >
            @if (editingLinkId() !== link.id) {
            <div class="link-display">
              <div class="link-content">
                <p class="link-url"><a [href]="link.url" target="_blank" rel="noopener">{{ link.url }}</a></p>
                @if (link.label) {
                  <p class="link-label">{{ link.label }}</p>
                }
                @if (link.description) {
                  <p class="link-description">{{ link.description }}</p>
                }
              </div>
              <div class="link-actions">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="onEditLink(link)"
                  [disabled]="isAnythingLoading()"
                >
                  {{ 'common.edit' | transloco }}
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="onDeleteLink(link.id)"
                  [disabled]="isAnythingLoading()"
                >
                  {{ 'common.delete' | transloco }}
                </button>
              </div>
            </div>
            }

            @if (editingLinkId() === link.id) {
            <div class="link-edit-form">
              <form [formGroup]="editLinkForm">
                <div class="form-group">
                  <label for="edit-url">{{ 'content_management.web_address' | transloco }} *</label>
                  <input
                    id="edit-url"
                    type="url"
                    class="form-control"
                    formControlName="url"
                    [disabled]="formDisabled()"
                  />
                  <cco-common-form-validation-messages
                    [control]="editLinkForm.get('url')"
                    [showErrors]="submitAttempted()"
                  ></cco-common-form-validation-messages>
                </div>

                <div class="form-group">
                  <label for="edit-label">{{ 'content_management.title' | transloco }}</label>
                  <input
                    id="edit-label"
                    type="text"
                    class="form-control"
                    formControlName="label"
                    [disabled]="formDisabled()"
                  />
                  <cco-common-form-validation-messages
                    [control]="editLinkForm.get('label')"
                    [showErrors]="submitAttempted()"
                  ></cco-common-form-validation-messages>
                </div>

                <div class="form-group">
                  <label for="edit-description">{{ 'common.description' | transloco }}</label>
                  <textarea
                    id="edit-description"
                    class="form-control"
                    formControlName="description"
                    rows="3"
                    [disabled]="formDisabled()"
                  ></textarea>
                  <cco-common-form-validation-messages
                    [control]="editLinkForm.get('description')"
                    [showErrors]="submitAttempted()"
                  ></cco-common-form-validation-messages>
                </div>

                <div class="form-actions">
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="onSaveEdit()"
                    [disabled]="formDisabled() || !editLinkForm.valid"
                  >
                    {{ 'common.save' | transloco }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="onCancelEdit()"
                    [disabled]="formDisabled()"
                  >
                    {{ 'common.cancel' | transloco }}
                  </button>
                </div>
              </form>
            </div>
            }
          </div>
          }

          <button
            type="button"
            class="btn btn-sm btn-outline-primary add-more-btn"
            (click)="onSelectType(template.type)"
            [disabled]="isAnythingLoading()"
            *transloco="let t"
          >
            + {{ t('common.add_more') }}
          </button>
        </div>
        }
      </div>
      }
    </div>

    @let selectedTemplateVariable = selectedTemplate();
    <!-- Add New Link Section -->
    @if (newLinkForm && selectedTemplateVariable) {
    <div class="add-link-section" #addLinkSection>
      <h3 *transloco="let t">{{t('content_management.new_link')}}</h3>

      <div class="selected-type-info">
        <p class="h5"><span *transloco="let t; scope:'profile'">{{t('profile.adding_link_type')}}</span>
          <strong class="ms-2">
            @if(selectedTemplateVariable.labelTranslationKey) {
              <span *transloco="let t; scope:selectedTemplateVariable.labelTranslationScope">{{t(selectedTemplateVariable.labelTranslationKey)}}</span>
            } @else {
              {{ selectedTemplateVariable.labelText ?? '' }}

            }
          </strong>
        </p>
      </div>

      <form [formGroup]="newLinkForm">
        <div class="form-group">
          <label for="new-url">{{ 'content_management.web_address' | transloco }} *</label>
          <input
            id="new-url"
            type="url"
            class="form-control"
            formControlName="url"
            [disabled]="formDisabled()"
            [placeholder]="
              selectedTemplate()?.placeholder || ''
            "
          />
          <cco-common-form-validation-messages
            [control]="newLinkForm.get('url')"
            [showErrors]="submitAttempted()"
          ></cco-common-form-validation-messages>
        </div>

        <div class="form-group">
          <label for="new-label">{{ 'content_management.title' | transloco }}</label>
          <input
            id="new-label"
            type="text"
            class="form-control"
            formControlName="label"
            [disabled]="formDisabled()"
          />
          <cco-common-form-validation-messages
            [control]="newLinkForm.get('label')"
            [showErrors]="submitAttempted()"
          ></cco-common-form-validation-messages>
        </div>

        <div class="form-group">
          <label for="new-description">{{ 'common.description' | transloco }}</label>
          <textarea
            id="new-description"
            class="form-control"
            formControlName="description"
            rows="3"
            [disabled]="formDisabled()"
          ></textarea>
          <cco-common-form-validation-messages
            [control]="newLinkForm.get('description')"
            [showErrors]="submitAttempted()"
          ></cco-common-form-validation-messages>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn btn-primary"
            (click)="onAddLink()"
            [disabled]="formDisabled() || !newLinkForm.valid"
            *transloco="let t"
          >
            {{ t('common.save') }}
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="newLinkForm.reset()"
            [disabled]="formDisabled()"
            *transloco="let t"
          >
            {{ t('common.cancel') }}
          </button>
        </div>
      </form>
    </div>
    }
  </div>
  }
</div>
